module.exports = __webpack_public_path__ + "static/media/corkease-2.81520620.jpg";